import { useEffect } from 'react'
import { fetchCustomScriptForPMS, fetchCustomScriptForSelfCheckin } from '@/apis/aipass'

const insertDomId = 'custom-script-block'

export const useCustomScript = (hotelId: string | undefined, target?: 'pms' | 'selfCheckIn' | 'selfCheckOut') => {
  const insertScript = (elm: HTMLElement, html: string) => {
    elm.innerHTML = html
    Array.from(elm.querySelectorAll('script')).forEach(oldScript => {
      const newScript = document.createElement('script')
      Array.from(oldScript.attributes).forEach(attr => newScript.setAttribute(attr.name, attr.value))
      newScript.appendChild(document.createTextNode(oldScript.innerHTML))
      oldScript.parentNode?.replaceChild(newScript, oldScript)
    })
  }

  useEffect(() => {
    if (!hotelId || !target) {
      return
    }
    const insertDom = document.getElementById(insertDomId)
    if (!insertDom || insertDom.children.length) {
      return
    }
    let api: any = fetchCustomScriptForPMS
    if (target === 'selfCheckIn') {
      api = fetchCustomScriptForSelfCheckin
    } else if (target === 'selfCheckOut') {
      api = fetchCustomScriptForSelfCheckin
    }

    api({ hotelId }).then(cs => {
      const textScript = cs.map(s => s.script).join('')
      if (textScript) {
        insertScript(insertDom, textScript)
      } else {
        insertDom.remove()
      }
    })
  }, [])
}
